export default __webpack_public_path__ + "static/media/dashIcon.a5901c0a.svg";